import type { IconSvgObject } from './types';

const ThreeDScaleIcon: IconSvgObject = [
  ["path", { d: "M12 13L17 17.5M12 13L7 17.5M12 13V8", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5008 3.5L11.9996 2L9.50118 3.5L9.5 6.5L11.9996 8L14.5008 6.5V3.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7.00083 17.5L4.49965 16L2.00118 17.5L2 20.5L4.49965 22L7.00083 20.5V17.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M22.0008 17.5L19.4996 16L17.0012 17.5L17 20.5L19.4996 22L22.0008 20.5V17.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ThreeDScaleIcon;
